<template>
  <div>
    <div id="barSimpleContainer" style="height: calc(35vh);"></div>
  </div>
</template>

<script>
    let echarts = require('echarts/lib/echarts')
    import 'echarts/lib/chart/bar';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';
    import 'echarts/lib/component/toolbox';
    export default {
        name: "BarSimple",
        data: function () {
            return {
            }
        },
        props: {
            chooseBridgeId: ''
        },
        mounted(){
            this.getData();
        },
        methods: {
            getData() {
                var xDataArray = ['一', '二', '三', '四', '五', '六', '七'];
                var dataArray = [45, 3, 22, 5, 4, 16, 6];
                this.drawChart(xDataArray, dataArray);
            },
            drawChart(xDataArray, dataArray) {
                var chart = echarts.init(document.getElementById('barSimpleContainer'));
                var option = {
                    title: {
                        text: '统计',
                        padding: [25, 0, 0, 58],
                        textStyle: {
                            color: '#697887'
                        }
                    },
                    color: 'rgba(63,160,255,0.5)',
                    toolbox: {
                        show : true,
                        feature : {
                            magicType : {show: true, type: ['line', 'bar']}
                        },
                        right:'9%'
                    },
                    xAxis: {
                        type: 'category',
                        data: xDataArray,
                        splitLine: {
                            show: false
                        },
                        axisLine: {lineStyle:{color: '#697887'}}
                    },
                    yAxis: {
                        type: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLine: {lineStyle:{color: '#697887'}}
                    },
                    series: [{
                        data: dataArray,
                        type: 'bar'
                    }]
                };
                chart.setOption(option,true);
            }
        }
    }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/echarts/BarSimple.vue